import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import NavBar from './components/NavBar';
import Dashboard from './pages/Dashboard';
import Receipts from './pages/Receipts';
import Carriers from './pages/Carriers';
import Lanes from './pages/Lanes';
import Settings from './pages/Settings';
import Login from './pages/Login';
import NotFound from './pages/NotFound';
import ManualReceipt from './pages/ManualReceipt';
import BatchReceipt from './pages/BatchReceipt';
import { getAuth, onAuthStateChanged } from 'firebase/auth';

function App() {
  const [user, setUser] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [navCollapsed, setNavCollapsed] = useState(false);
  
  // Listen for auth state changes
  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
      if (currentUser) {
        console.log('User authenticated in App.tsx:', currentUser.uid);
      } else {
        console.log('No user authenticated in App.tsx');
      }
    });
    
    // Cleanup the listener on unmount
    return () => unsubscribe();
  }, []);

  const toggleNavbar = () => {
    setNavCollapsed(!navCollapsed);
  };
  
  // Show loading state
  if (loading) {
    return (
      <div className="loading-app">
        <div className="login-spinner"></div>
        <p>Loading application...</p>
      </div>
    );
  }
  
  return (
    <Router>
      <div className="app">
        {user && <NavBar isCollapsed={navCollapsed} onToggle={toggleNavbar} />}
        <main className={`content ${user && navCollapsed ? 'with-collapsed-nav' : ''}`}>
          <Routes>
            <Route path="/login" element={user ? <Navigate to="/" /> : <Login />} />
            
            <Route path="/" element={
              user ? <Dashboard /> : <Navigate to="/login" />
            } />
            
            <Route path="/receipts" element={
              user ? <Receipts /> : <Navigate to="/login" />
            } />
            
            <Route path="/manual-receipt" element={
              user ? <ManualReceipt /> : <Navigate to="/login" />
            } />
            
            <Route path="/batch-receipt" element={
              user ? <BatchReceipt /> : <Navigate to="/login" />
            } />
            
            <Route path="/carriers" element={
              user ? <Carriers /> : <Navigate to="/login" />
            } />
            
            <Route path="/lanes" element={
              user ? <Lanes /> : <Navigate to="/login" />
            } />
            
            <Route path="/settings" element={
              user ? <Settings /> : <Navigate to="/login" />
            } />
            
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
